import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';
import { RadioGroupButton } from 'ui/templateEdit';
import { Body1Bold } from 'ui/theme';

const SelectorButtonsGroup = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

const StyledRadioGroupButton = styled(RadioGroupButton)`
  width: fill-available;
`;

interface ListTypeProps {
  listType: string;
  updateListType: (value: string) => void;
}

export function ListTypeSelector({ listType, updateListType }: ListTypeProps) {
  return (
    <div>
      <Body1Bold>List type</Body1Bold>
      <SelectorButtonsGroup>
        <StyledRadioGroupButton
          id="name"
          isChecked={listType === 'Standard'}
          name={listType}
          onClick={() => {
            updateListType('Standard');
          }}
        >
          <Tooltip tooltipContent="Default list type" tooltip-placement="top" isUnderlined>
            Standard
          </Tooltip>
        </StyledRadioGroupButton>

        <StyledRadioGroupButton
          id="name"
          isChecked={listType === 'Suppression'}
          name={listType}
          onClick={() => {
            updateListType('Suppression');
          }}
        >
          <Tooltip
            tooltipContent="Users to exclude from a list. Does not unsubscribe users from a channel."
            isUnderlined
          >
            Suppression
          </Tooltip>
        </StyledRadioGroupButton>

        <StyledRadioGroupButton
          id="name"
          isChecked={listType === 'Internal'}
          name={listType}
          onClick={() => {
            updateListType('Internal');
          }}
        >
          <Tooltip tooltipContent="Lists you can send proofs to" isUnderlined>
            Internal
          </Tooltip>
        </StyledRadioGroupButton>
      </SelectorButtonsGroup>{' '}
    </div>
  );
}
